<template>
  <div class="uk-container">
    <div class="uk-flex uk-flex-center">
      <div class="practice">
        <div class="uk-card uk-card-default">
          <div class="uk-card-header uk-text-center">
            <h3 class="uk-card-title">{{ data.name }}</h3>
            <p class="uk-text-meta">{{ data.id }}</p>
          </div>
          <div class="uk-card-body uk-text-center">
            <p>
              <b>Address</b>:<br>
              {{ data.location.house }} {{ data.location.street }}<br>
              {{ data.location.city }}<br>
              {{ data.location.postcode }}
            </p>
            <p><b>Practice</b>: {{ data.phone.primary }}</p>
            <p><b>On-Call</b>: {{ data.phone.secondary }}</p>
            <p><b>Area</b>: {{ this.$helpers.getAreaName(data.area) }}</p>
          </div>
        </div>

        <div class="uk-margin-top uk-box-shadow-large">
          <iframe width="100%" height="100%" :src="`https://maps.google.com/maps?q=${data.location.geopoint.latitude},${data.location.geopoint.longitude}+(${encodeURI(data.name)})&z=9&output=embed`" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" style="min-height: 400px;" />
        </div>
      </div>

      <div class="availability uk-width-auto uk-margin-left uk-box-shadow-large">
        <div>
          <div class="uk-card uk-card-default">
            <div class="uk-card-header uk-text-center">
              <h3 class="uk-card-title">Availability</h3>
            </div>
            <div class="uk-card-body uk-padding-remove">
              <timetable :data="data.availability" type="view" />
            </div>
          </div>
        </div>

        <!-- <iframe width="100%" height="100%" :src="`https://maps.google.com/maps?q=${data.location.geopoint._lat},${data.location.geopoint._long}+(${encodeURI(data.n)})&z=9&output=embed`" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" /> -->
      </div>
    </div>
  </div>
</template>

<script>
import Timetable from '@/components/Timetable.vue'

export default {
  name: 'ViewDentistInfo',

  components: {
    Timetable
  },

  computed: {
    data() {
      return this.$store.getters['dentists/find'](this.$route.params.id)
    }
  }
}
</script>

<style lang="scss" scoped>
  .practice {
    width: 100%;
    max-width: 400px;
  }
</style>
